/**
 * Format an absolute time as a relative phrase ("3 days ago", "in 5 hours").
 * Uses the browser's Intl.RelativeTimeFormat for locale-aware output.
 */
const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export function relativeTime(when: string | Date): string {
    const date = typeof when === 'string' ? new Date(when) : when;
    const diffMs = date.getTime() - Date.now();
    const diffSec = Math.round(diffMs / 1000);

    if (Math.abs(diffSec) < 60) return formatter.format(diffSec, 'second');
    const diffMin = Math.round(diffSec / 60);
    if (Math.abs(diffMin) < 60) return formatter.format(diffMin, 'minute');
    const diffHour = Math.round(diffMin / 60);
    if (Math.abs(diffHour) < 24) return formatter.format(diffHour, 'hour');
    const diffDay = Math.round(diffHour / 24);
    if (Math.abs(diffDay) < 30) return formatter.format(diffDay, 'day');
    const diffMonth = Math.round(diffDay / 30);
    if (Math.abs(diffMonth) < 12) return formatter.format(diffMonth, 'month');
    return formatter.format(Math.round(diffMonth / 12), 'year');
}
